import { TrendingUp } from 'lucide-react';
import { getLevelNote } from '@/config/curriculumLevels';

/**
 * Tells a family when the year they are browsing reaches a full NZC level
 * beyond its own year — Year 6 does so in every term, Year 5 maths from Term 3.
 *
 * Renders nothing when there is nothing to declare, including for Year 7, whose
 * above-level lessons are labelled individually in the lesson title or week
 * unit name instead (see config/curriculumLevels.js).
 */
const CurriculumLevelNote = ({ year, term }) => {
  const note = getLevelNote(year, term);
  if (!note) return null;

  return (
    <div
      data-testid="curriculum-level-note"
      className="flex items-start gap-3 rounded-2xl border border-moana/20 bg-moana/5 px-4 py-3 mb-4 animate-fadeInUp stagger-2"
    >
      <TrendingUp className="w-4 h-4 text-moana shrink-0 mt-0.5" aria-hidden="true" />
      <div>
        <p className="text-sm font-semibold text-moana">{note.headline}</p>
        <p className="text-sm text-slate-600 leading-relaxed">{note.detail}</p>
      </div>
    </div>
  );
};

export default CurriculumLevelNote;
